import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

export const initialState = {
    currentUser: null,
    loading: false,
    error: false,
    errorMsg: "",
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        loginStart(state) {
            state.loading = true;
            state.error = false;
            state.errorMsg = "";
        },
        loginSuccess(state, action) {
            state.currentUser = action.payload;
            state.loading = false;
            state.errorMsg = "";
            state.error = false;
        },
        loginEnd(state) {
            state.loading = false;
        },
        registerStart(state) {
            state.loading = true;
            state.error = false;
            state.errorMsg = "";
        },
        registerSuccess(state) {
            state.loading = false;
            state.error = false;
            state.errorMsg = "";
        },
        apiError(state, action) {
            state.loading = false;
            state.error = true;
            state.errorMsg = action.payload;
        },
        clearError(state) {
            state.loading = false;
            state.error = false;
            state.errorMsg = "";
        },
        logout(state) {
            state.currentUser = null;
            state.loading = false;
            state.error = false;
            state.errorMsg = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(REHYDRATE, (state) => {
            state.loading = false;
            state.error = false;
            state.errorMsg = "";
        });
    }
});

export const {
    loginStart,
    loginSuccess,
    loginEnd,
    apiError,
    clearError,
    registerStart,
    registerSuccess,
    logout
} = userSlice.actions

export default userSlice.reducer;
